<template>
    <div v-if="visible" v-dusk="'errors-zone'" ref="alert" class="alert alert-danger alert-dismissible" role="alert">
        <template v-if="errors.message">
            {{ errors.message }}
        </template>
        <template v-if="errors.errors">
            <ul>
                <template v-for="error in errors.errors">
                    <li>{{ (typeof error === 'string') ? error : error[0] }}</li>
                </template>
            </ul>
        </template>
        <button type="button" class="close" aria-label="Close" @click="dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</template>

<script>
    export default {
        name: 'ErrorsZone',

        props: ['errors'],

        data() {
            return {
                dismissed: false,
            }
        },

        methods: {
            dismiss() {
                this.dismissed = true;
            },
        },

        computed: {
            hasErrors() {
                return this.errors && (this.errors.length > 0 || Object.keys(this.errors).length > 0);
            },

            visible() {
                return this.hasErrors && !this.dismissed;
            },
        },

        watch: {
            errors(newValue, oldValue) {
                this.dismissed = false;
            },
        },
    }
</script>
